<div
  aria-live="polite"
  aria-atomic="false"
  class="fixed top-4 right-4 z-9999 flex flex-col gap-3 w-full max-w-sm pointer-events-none"
>
  @for (toast of topRightToasts(); track trackById($index, toast)) {
    <div
      class="toast-item pointer-events-auto flex items-start gap-3
             bg-white border border-ui-border rounded-lg shadow-lg
             px-4 py-3.5 overflow-hidden"
      [class]="'toast-item toast-' + toast.type"
      role="alert"
    >
      <fa-icon
        [icon]="iconFor(toast.type)"
        class="toast-icon mt-0.5 shrink-0 text-base leading-none"
      />

      <p class="flex-1 text-sm leading-5 text-ink font-manrope">{{ toast.message }}</p>

      <button
        type="button"
        (click)="dismiss(toast.id)"
        class="shrink-0 w-5 h-5 flex items-center justify-center rounded
               text-ink-muted hover:text-ink transition-colors cursor-pointer mt-0.5"
        aria-label="Cerrar notificación"
      >
        <fa-icon [icon]="faXmark" class="text-xs" />
      </button>

      <div
        class="toast-progress absolute bottom-0 left-0 h-0.5 rounded-b-lg"
        [style.animation-duration]="toast.duration + 'ms'"
      ></div>
    </div>
  }
</div>

<div
  aria-live="polite"
  aria-atomic="false"
  class="fixed bottom-4 right-4 z-9999 flex flex-col gap-3 w-full max-w-sm pointer-events-none"
>
  @for (toast of bottomRightToasts(); track trackById($index, toast)) {
    <div
      class="toast-item pointer-events-auto flex items-start gap-3
             bg-white border border-ui-border rounded-lg shadow-lg
             px-4 py-3.5 overflow-hidden"
      [class]="'toast-item toast-' + toast.type"
      role="alert"
    >
      <fa-icon
        [icon]="iconFor(toast.type)"
        class="toast-icon mt-0.5 shrink-0 text-base leading-none"
      />

      <p class="flex-1 text-sm leading-5 text-ink font-manrope">{{ toast.message }}</p>

      <button
        type="button"
        (click)="dismiss(toast.id)"
        class="shrink-0 w-5 h-5 flex items-center justify-center rounded
               text-ink-muted hover:text-ink transition-colors cursor-pointer mt-0.5"
        aria-label="Cerrar notificación"
      >
        <fa-icon [icon]="faXmark" class="text-xs" />
      </button>

      <div
        class="toast-progress absolute bottom-0 left-0 h-0.5 rounded-b-lg"
        [style.animation-duration]="toast.duration + 'ms'"
      ></div>
    </div>
  }
</div>
